import { use_slice_ui } from '@/hooks/store/use_slices';

export function G_VIEW__column_center_image_edit() {
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * EVENTS
   */

  /*
   * HTML
   */
  if (!g_general__ui_disabled) return null;

  return (
    <div
      className="absolute inset-0 size-full flex-center px-4 py-2 text-xs text-bar-foreground 
  bg-black/80"
    >
      ⚠️ Image is not editable
    </div>
  );
}
